import DebugModel from "../../debug/model/DebugModel";

export default class PlayerModel {
    constructor() {
        this._playerName = '';

        if (DebugModel.hasPlayerNameOverride()) {
            console.warn(`Player name override detected: ${DebugModel.playerName}`);
            this._playerName = DebugModel.playerName;
        }
    }

    getTrimmedPlayerName() {
        return this._playerName?.trim();
    }

    get playerName() {
        return this._playerName;
    }

    set playerName(value) {
        this._playerName = value;
    }

    toObject() {
        return {
            playerName: this._playerName,
        };
    }

    load(obj) {
        this._playerName = obj.playerName;
    }
}